import { api } from './api';
import { API_ENDPOINTS } from './endpoints';

export interface Brand {
  id: number;
  name: string;
  slug: string;
  image?: string;
  active: boolean;
  products_count?: number;
}

export const brandService = {
  getAll: (params?: any) => api.get(API_ENDPOINTS.BRANDS.INDEX, { params }),
  
  create: (data: { name: string; description?: string; image?: string; active?: boolean }) => 
    api.post(API_ENDPOINTS.BRANDS.STORE, data),
  
  update: (id: number, data: { name?: string; description?: string; image?: string; active?: boolean }) => 
    api.put(API_ENDPOINTS.BRANDS.UPDATE(id), data),
  
  delete: (id: number) => 
    api.delete(API_ENDPOINTS.BRANDS.DELETE(id)),
};
